import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { PostErrorResponse, PostVerificationRequest } from './types';
import { GetVerificationResponse } from '../get';

type VerificationType = 'email' | 'mobile';

export const postVerification = async (data: PostVerificationRequest, type: VerificationType = 'email',  lang = 'en', token: string | null | undefined): Promise<GetVerificationResponse> => {
	const headers = {
		'Content-Type': 'application/json',
		...(token && { "X-XSRF-TOKEN": token }),
	};
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/verify/${type}/validate?${queryParams.join('&')}`, {
		method: 'POST',
		credentials: 'include',
		headers,
		body: JSON.stringify(data),
	})
	.then((res) => {
		if (res.ok) return res.json().then(response => response as GetVerificationResponse);
		return res.json().then(errorResponse => {
			throw errorResponse as PostErrorResponse
		});
	})
	.then((successResponse) => successResponse)
	.catch((error: PostErrorResponse) => {
		throw error;
	});
};
